import { AlertErrorCircle } from '@/assets/icons'

type DeletedFileBadgeProps = {
  /** Appends the count of events still attributed to the deleted file. Omitted or 0 renders no suffix. */
  linkedEvents?: number
}

/**
 * Marks a source-file row whose underlying file no longer resolves. Shared by the Medical
 * Chronology and Timeline Source Files tabs and by both Add Files "Included in …" drawers, so the
 * copy and treatment stay identical across all four.
 */
export function DeletedFileBadge({ linkedEvents }: DeletedFileBadgeProps) {
  // Falsy covers both an omitted count and 0: "0 linked events" is noise, since the point of the
  // suffix is to say what the attorney still has after the source is gone.
  const suffix = linkedEvents ? ` · ${linkedEvents} linked ${linkedEvents === 1 ? 'event' : 'events'}` : ''

  return (
    <span className="flex shrink-0 items-center gap-1 text-red-800">
      <AlertErrorCircle className="h-3.5 w-3.5 shrink-0" aria-hidden />
      <span className="text-xs font-medium leading-4">This file has been deleted{suffix}</span>
    </span>
  )
}
